import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AppStack from '../../common/AppStack';
import StoreCreationStockContentSelection from './StoreCreationStockContentSelection';

const StoreCreationStockContentStep = ({
  loading,
  createOptions,
  formState,
  setFormState
}) => {
  const [viewState, setViewState] = useState({
    showAllStockContent: false,
    search: '',
    pageIndex: 1
  });

  return (
    <AppStack style={{ gap: 10, paddingTop: 10 }}>
      <StoreCreationStockContentSelection
        createOptions={createOptions}
        formState={formState}
        loading={loading}
        setFormState={setFormState}
        setViewState={setViewState}
        viewState={viewState}
      />
    </AppStack>
  );
};

StoreCreationStockContentStep.propTypes = {
  createOptions: PropTypes.object,
  formState: PropTypes.object,
  loading: PropTypes.bool,
  setFormState: PropTypes.func
};

export default StoreCreationStockContentStep;
